export enum SchemaProperty {
    ADDRESSLINE1 = 'addressLine1',
    ADDRESSLINE2 = 'addressLine2',
    STATE= 'state',
    ZIP = 'zip',
    COUNTRY = 'country',
    EMAIL = 'Email',
    FIRSTNAME = 'firstName',
    LASTNAME = 'lastName',
    CONFIRMEMAIL = 'confirmEmail',
    MEMBERID = 'memberId',
    PASSWORD = 'pass_word',
    CONFIRM_PASSWORD = 'confirmPassword',
    MIDDLENAME = 'middleName',
    DATEOFBIRTH = 'dateOfBirth',
    GOVERNMENTID = 'governmentId',
    PHONETYPE = 'phoneType',
    PHONE = 'phone',
    NEWSLETTERLANGUAGE = 'newsLetterLanguage',
    TITLE = 'title',
    VATID = 'vatId',
    SORTCODE = 'sortCode',
    ACCOUNTNUMBER = 'accountNumber',
    ACCOUNTNAME = 'accountName',
    ACCOUNTREFERENCENUMBER = 'accountReferenceNumber',
    BANKCODE = 'bankCode',
    IBAN = 'iban',
    BIC = 'bic',
    CHECKDIGIT = 'checkDigit',
    CLEARINGNUMBER = 'clearingNumber',
    BANKNAME = 'bankName',
    VATPAYER='vatPayer',
    BUSINESSENTITYNAME = 'businessEntityName',
    CITY = 'city',
    BSNNUMBER = 'bsnNumber',
    ACCOUNTTYPE = 'accountType',
    PAYTYPE = 'payType'
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/schema-property.enum.ts